import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'

import './CoachEmailInfo.scss'
import { ReactComponent as MailIcon } from '../../../../assets/images/common/icons/mail-icon.svg'

const CoachEmailInfo = ({ leadCoach }) => (
  <div id='CoachEmailInfo' className='mb-4'>
    <MailIcon className='email-icon' />
    <div className='email-text'>
      <Trans
        i18nKey='programs.registration.coachEmailInfo.contactCoach'
        components={{
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          anchor: <a className='email-address' href={`mailto:${leadCoach.email}`} />,
        }}
        values={{ name: `${leadCoach.firstName} ${leadCoach.lastName}`, email: leadCoach.email }}
      />
    </div>
  </div>
)

CoachEmailInfo.propTypes = {
  leadCoach: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
}

export default CoachEmailInfo
